<template>
  <b-container
    class="bv-example-row"
    fluid
  >
    <b-row align-h="end">
      <b-button
        variant="success"
        @click="openFieldModal"
      >
        เพิ่มข้อมูล
      </b-button>
    </b-row>
    <b-row style="padding-top: 2rem;">
      <b-table
        responsive
        striped
        hover
        bordered
        :fields="fields"
        :items="items"
      >
        <template
          slot="id"
          slot-scope="data"
        >
          <div class="col-right">
            {{ data.item.id }}
          </div>
        </template>
        <template
          slot="remarks"
          slot-scope="data"
        >
          <div class="col-left">
            {{ data.item.remarks }}
          </div>
        </template>
        <template
          slot="created_at"
          slot-scope="data"
        >
          <div class="col-center">
            {{ data.item.created_at }}
          </div>
        </template>
        <template
          slot="action"
          slot-scope="data"
        >
          <b-container fluid>
            <b-row>
              <b-col>
                <b-button
                  variant="warning"
                  @click="openFieldModal(data.item.id)"
                >
                  แก้ไข
                </b-button>
              </b-col>
              <b-col>
                <b-button
                  variant="danger"
                  @click="openDeleteModal(data.item.id)"
                >
                  ลบ
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </template>
      </b-table>
    </b-row>
    <sweet-modal ref="inputModal">
      <input-modal :fields.sync="inputFields" />
      <b-row>
        <b-col cols="auto">
          <b-button
            variant="success"
            @click="submit"
          >
            บันทึก
          </b-button>
        </b-col>
        <b-col cols="auto">
          <b-button
            @click="$refs['inputModal'].close()"
          >
            ยกเลิก
          </b-button>
        </b-col>
      </b-row>
    </sweet-modal>
    <b-modal
      ref="confirmDelete"
      title="ยืนยันการลบ"
      ok-title="ยืนยัน"
      cancel-title="ยกเลิก"
      @ok="delRemark"
    >
      <confirm-modal />
    </b-modal>
  </b-container>
</template>

<script>
  import {mapActions} from "vuex"
  import InputModal from "../../components/Settings/InputModal"
  import ConfirmModal from "../../components/Settings/ConfirmModal"

  export default {
    name: "CancelReason",
    components: {
      InputModal,
      ConfirmModal
    },
    data() {
      return {
        fields: [
          {
            key: 'id',
            label: 'ID',
            isInputField: false,
          },
          {
            key: 'reason',
            label: 'REASON',
            isInputField: true,
            isSpecialField: false,
            fieldType: 'text'
          },
          {
            key: 'created_at',
            label: 'DATE CREATED',
            isInputField: false,
          },
          {
            key: 'action',
            label: 'ACTIONS',
            isInputField: false,
          }
        ],
        inputFields: [
          {
            key: 'reason',
            label: 'Reason',
            fieldType: 'text',
            value: '',
            required: true,
            default: ''
          },
        ],
        items: [],
        itemSelected: null,
        modalTitle: "",
        deleteRemarkIdSelected: null,
        password: '',
      }
    },
    methods: {
      ...mapActions({
        getRemark: "CancelReason/getReasonList",
        createRemark: "CancelReason/createReason",
        updateRemark: "CancelReason/updateReason",
        deleteRemark: "CancelReason/deleteReason",

      }),
      async openFieldModal(remarkId = null) {
        this.itemSelected = this.items.find((item) => {
          return item.id === remarkId;
        }) || null;

        this.clearInputField()
        this.$refs['inputModal'].open();
      },
      async openDeleteModal(remarkId) {
        this.deleteRemarkIdSelected = remarkId

        const { value: password } = await this.$swal.fire({
          title: 'กรอกรหัสผ่านเพื่อดำเนินการต่อไป',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          this.password = password
          this.delRemark()
        } else {
          this.password = ''
          return
        }
        // this.$refs['confirmDelete'].show();
      },
      async submit() {
        let payload = {}
        let malformedCheck = false
        this.inputFields.forEach(el => {
          if (el.value === null || el.value === '' || el.value === undefined) {
            if (!el.required) {
              payload[el.key] = el.default
            } else {
              malformedCheck = true
              this.$swal.fire('กรอกข้อมูลไม่ครบ')
            }
          } else {
            payload[el.key] = el.value;
          }
        })

        if (malformedCheck) {
          return;
        }

        this.$refs['inputModal'].close()

        const { value: password } = await this.$swal.fire({
          title: 'กรอกรหัสผ่านเพื่อดำเนินการต่อไป',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          this.password = password
        } else {
          this.password = ''
          this.$refs['inputModal'].open()
          return
        }

        this.$store.state.isLoading = true

        if (this.itemSelected) {
          try {
            var res = await this.updateRemark({
              payload,
              id: this.itemSelected.id,
              password: this.password
            });
          } catch (e) {
            this.password = ''
            this.$swal.fire('เกิดข้อผิดพลาด', e.message, 'error')
            this.$store.state.isLoading = false
            return
          }

        } else {
          try {
            var res = await this.createRemark({ ...payload, password: this.password });
          } catch (e) {
            this.password = ''
            this.$swal.fire('เกิดข้อผิดพลาด', e.message, 'error')
            this.$store.state.isLoading = false
            return
          }
        }

        try {
          this.items = await this.getRemark()
        } catch (e) {
          this.password = ''
          this.$swal.fire('เกิดข้อผิดพลาด', e.message, 'error')
          this.$store.state.isLoading = false
          return
        }
        this.$refs['inputModal'].close()
        this.itemSelected = null
        this.password = ''
        await this.$swal.fire("บันทึกเสร็จสิ้น")
        this.$store.state.isLoading = false

      },
      clearInputField() {
        if (this.itemSelected) {
          this.inputFields.forEach(el => {
            el.value = this.itemSelected[el.key]
          })
        } else {
          this.inputFields.forEach(el => {
            el.value = ''
          })
        }
        this.modalTitle = this.itemSelected ? 'แก้ไขข้อมูล' : 'เพิ่มข้อมูล';
      },
      async delRemark() {
        this.$store.state.isLoading = true

        try {
          let res = await this.deleteRemark({ id: this.deleteRemarkIdSelected, password: this.password })
        } catch (e) {
          this.password = ''
          this.$swal.fire('เกิดข้อผิดพลาด', e.message, 'error')
          this.$store.state.isLoading = false
          return
        }

        try {
          this.items = await this.getRemark()
        } catch (e) {
          this.password = ''
          this.$swal.fire('เกิดข้อผิดพลาด', e.message, 'error')
          this.$store.state.isLoading = false
          return
        }
        this.password = ''
        this.deleteRemarkIdSelected = null
        await this.$swal.fire('ลบข้อมูลเสร็จสิ้น')
        this.$store.state.isLoading = false
        // this.$refs['confirmDelete'].hide();
      }
    },
    async mounted() {
      this.items = await this.getRemark()
    }
  }
</script>

<style scoped>

</style>
